import { useEffect } from 'react'
import { z } from 'zod'
import { useAtom } from 'jotai'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { currentStep } from '@/app/store'
import { personalFormSchema } from './components/PersonalInfoForm'
import { addressFormSchema } from './components/AddressForm'
import { bankFormSchema } from './components/BankInfoForm'

const formSchema = z.object({
  personalInfo: personalFormSchema,
  address: addressFormSchema,
  bankAccount: bankFormSchema,
})

export type formData = z.infer<typeof formSchema>

export default function useNewPanModal() {
  const [step, setStep] = useAtom(currentStep)

  useEffect(() => {
    setStep(0)
  }, [])

  const form = useForm<formData>({ resolver: zodResolver(formSchema) })

  const steps = {
    personalInfo: step === 0,
    address: step === 1,
    bankInfo: step === 2,
    sentProposal: step === 3,
  }

  const title = [
    'Informações do cliente',
    'Endereço do cliente',
    'Dados bancários do cliente',
  ]

  return {
    steps,
    title,
    form,
    step,
  }
}
